import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

// 用户管理
const UserView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/UserInfo/UserView.vue');

// 卡密管理
const CdkView = () =>
  import( /* webpackChunkName: "extra" */ 'src/pages/Cdk/CdkView.vue');


// 登录界面
const Login = () =>
  import( /* webpackChunkName: "pages" */ 'src/pages/Pages/Login.vue');




let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [{
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
};

const routes = [{
    path: '/',
    redirect: '/user',
    name: 'Home1'
  },
  // pagesMenu,
  authPages,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'cdk',
        name: '卡密管理',
        components: {
          default: CdkView
        }
      },
      {
        path: 'user',
        name: '用户管理',
        components: {
          default: UserView
        }
      }
      
    ]
  },
  {
    path: '*',
    component: NotFound
  }
];

export default routes;
